//Hardwar
import camera1 from "../images/surveillanceSystems/cameras/TR_D2251WDIR4-v2.png";
import camera2 from "../images/surveillanceSystems/cameras/TR-D2253WDZIR7 v2 2.7-13.5.png";
import camera3 from "../images/surveillanceSystems/cameras/TR_D3251WDIR3W-v2.png";
import camera4 from "../images/surveillanceSystems/cameras/TR_D2183IR6-v3-1.png";
import camera5 from "../images/surveillanceSystems/cameras/TR-D8251WDIR3 v3 3.6 1.jpg";
import camera6 from "../images/surveillanceSystems/cameras/TR-D4251WDIR2-v3-2.8-1.jpg";
import camera7 from "../images/surveillanceSystems/cameras/TR-D6124IR10-v3-4.3-86.jpg";
import camera8 from "../images/surveillanceSystems/cameras/TR-D3121IR2 v6 (B) 3.6.png";
import camera9 from "../images/surveillanceSystems/cameras/TR-H2B5 3.6.jpg";

//NVR
import nvr1 from "../images/surveillanceSystems/nvr/8800R-64.png";
import nvr2 from "../images/surveillanceSystems/nvr/8800R-128.png";
import nvr3 from "../images/surveillanceSystems/nvr/Server8800R-160-A8-S.jpg";
import nvr4 from "../images/surveillanceSystems/nvr/MiniNVR AnyIP 4.jpg";
import nvr5 from "../images/surveillanceSystems/nvr/MiniNVR AnyIP 9.png";
import nvr6 from "../images/surveillanceSystems/nvr/MiniNVR AnyIP 16.png";

//Licenses
import Face_Recognition from "../images/surveillanceSystems/licenses/Face_Recognition.gif";
import Neuro_Detector from "../images/surveillanceSystems/licenses/Neuro_Detector.gif";
import Neuro_Counter from "../images/surveillanceSystems/licenses/Neuro_Counter.gif";
import Crowd_Detector from "../images/surveillanceSystems/licenses/Crowd_Detector.gif";
import Pose_Detector from "../images/surveillanceSystems/licenses/Pose_Detector.gif";
import Workplace_Detector from "../images/surveillanceSystems/licenses/Workplace_Detector.gif";
import Fire_and_Smoke from "../images/surveillanceSystems/licenses/Fire_and_Smoke.gif";
import Queue_Detector from "../images/surveillanceSystems/licenses/Queue_Detector.gif";
import Heat_Map from "../images/surveillanceSystems/licenses/Heat_Map.gif";

export const hardware = {
  cameras: [
    {
      id: "1",
      number: "1",
      vector: camera1,
      title: "TR-D2251WDIR4 v2 2.8",
      description:
        "TRASSIR TR-D2251WDIR4 v2 2.8 is a 5 MP smart IP bullet camera designed for intelligent monitoring. Equipped with motion detection, virtual line crossing, intrusion alerts, and people counting, it ensures proactive security. Combined with WDR 120 dB and 40 m IR night vision, it delivers sharp images in any lighting.",
    },
    {
      id: "2",
      number: "2",
      vector: camera2,
      title: "TR-D2253WDZIR7 v2 2.7-13.5",
      description:
        "A 5 MP IP bullet camera with motorized zoom (2.7-13.5 mm), built for smart detection: motion detection (people, cars, faces), virtual line crossing, area intrusion & loitering. Offers long-range IR (70 m) night vision, WDR 120 dB + 3D DNR to keep image quality crisp in challenging light.",
    },
    {
      id: "3",
      number: "3",
      vector: camera3,
      title: "TR-D3251WDIR3 v2 2.8",
      description:
        "This 5 MP dome camera includes built-in Wi-Fi for flexible deployment, plus people counting, motion, car & face detection. It detects intrusion, virtual line crossing, and loitering. With WDR 120 dB and 30 m IR night vision, it delivers sharp images even in low-light or high contrast scenarios.",
    },
    {
      id: "4",
      number: "4",
      vector: camera4,
      title: "TR-D2183ZIR6 v3 2.7-13.5",
      description:
        "An 8 MP super-high-definition bullet camera featuring motorized zoom (2.7-13.5 mm) with smart analytics like virtual line crossing, abandoned/missing object detection, crowd & sound events, defocus and scene change alerts.",
    },
    {
      id: "5",
      number: "5",
      vector: camera5,
      title: "TR-D8251WDIR3 v3 3.6",
      description:
        "This rugged 5 MP sphere camera brings face, people, vehicle detection, line crossing, area intrusion, loitering functions—all powered by smart onboard analytics. With real WDR 120 dB, very low light sensitivity, and up to 30 m IR range, it delivers reliable monitoring in challenging lighting and weather.",
    },
    {
      id: "6",
      number: "6",
      vector: camera6,
      title: "TR-D4251WDIR2 v3 2.8",
      description:
        "A durable, vandal-proof dome camera offering face, people & vehicle detection, line crossing and intrusion analytics. With WDR 120 dB, 0.003 lux sensitivity, and 20 m IR, it captures crisp detail even in tough light or low-light scenarios. Perfect for discrete but smart coverage.",
    },
    {
      id: "7",
      number: "7",
      vector: camera7,
      title: "TR-D6124IR10 v3 4.3-86",
      description:
        "Zoom in where it counts — this PTZ speed dome delivers real-time people detection, zone intrusion alerts, line crossing analytics, and 100 m IR visibility. With WDR 120 dB and ultra-low light sensitivity (0.002 lux), it sees through glare, shadows, and distance",
    },
    {
      id: "8",
      number: "8",
      vector: camera8,
      title: "TR-D3121IR2 v6 (B) 3.6",
      description:
        "Smart surveillance simplified — motion, people detection, virtual line crossing, and area intrusion built in. Combined with 25 m IR night vision, WDR 120 dB, defog and corridor mode, this dome ensures accurate detection even in low light or challenging conditions.",
    },
    {
      id: "9",
      number: "9",
      vector: camera9,
      title: "TR-H2B5 3.6",
      description:
        "Reliable analog viewing with smart image optimization — this weatherproof 2 MP outdoor camera features DWDR (105 dB), low-light sensitivity (0.01 lux), and 25 m IR night vision. Built tough with IP67 protection and fully compatible with AHD / HD-CVI / HD-TVI formats.",
    },
  ],
  nvr: [
    {
      id: "10",
      number: "1",
      vector: nvr1,
      title: "NeuroStation 8800R/64 INT",
      description:
        "Handles up to 64 IP cameras with TRASSIR’s intelligent OS, delivering neural-network-powered analytic modules that cut down false alarms while enabling advanced detection (motion, intrusion, etc.). Supports modern video codecs and offers multi-output display for superior monitoring.",
    },
    {
      id: "11",
      number: "2",
      vector: nvr2,
      title: "NeuroStation 8800R/128 INT",
      description:
        "Supports up to 128 IP cameras, powered by neural-network analytics to sharply reduce false positives. Comes with multiport outputs, multiple USB interfaces, and industry-grade video compression to ensure smooth viewing and efficient storage.",
    },
    {
      id: "12",
      number: "3",
      vector: nvr3,
      title: "NeuroStation 8800R/160-A8-S INT",
      description:
        "Built for large installations, this model manages up to 160 IP cameras with TRASSIR’s neural network analytics—offering precision detection, less false alerts, and comprehensive monitoring. Featuring multiple display outputs and robust video compression (H.265+, etc.).",
    },
    {
      id: "13",
      number: "4",
      vector: nvr4,
      title: "TRASSIR MiniNVR AnyIP 4",
      description:
        "Highly functional solution designed to expand existing and build new CCTV systems based on IP video cameras running TRASSIR OS (Linux). The device allows you to connect up to 4 network cameras of any supported manufacturer with a recording resolution of up to 8 megapixels.",
    },
    {
      id: "14",
      number: "5",
      vector: nvr5,
      title: "TRASSIR MiniNVR AnyIP 9",
      description:
        "Compact, high-performance recording for small-to-medium CCTV setups. Handles up to 32 IP camera channels, supports H.265+ / H.265 / H.264 compression, and fits two HDDs for reliable video retention—all in a low-power form factor.",
    },
    {
      id: "15",
      number: "6",
      vector: nvr6,
      title: "TRASSIR MiniNVR AnyIP 16",
      description:
        "Scale safely with this 16-camera IP NVR designed for growing systems. With dual monitor outputs (HDMI + VGA), support for 8 MP resolution, two HDD/SSD bays, USB 2.0",
    },
  ],
};

export const software = {
  licenses: [
    {
      id: "16",
      number: "1",
      vector: Face_Recognition,
      title: "Face Recognition",
      description:
        "Detects and identifies faces from any angle (including profiles) and compares them instantly with your database. Can recognize attributes like hair color, glasses or headwear, filter out fake photos, and search past footage—all ideal for access control, loss prevention, and secure environments.",
    },
    {
      id: "17",
      number: "2",
      vector: Neuro_Detector,
      title: "Neuro Detector",
      description:
        "Uses neural-net object detection to reliably identify people, vehicles, bikes, etc., and triggers alerts only when defined zones are crossed. Strongly reduces false activations (trees, animals, noise) so security teams can trust what’s happening. Works with offloaded analytics too—so you can centralize processing.",
    },
    {
      id: "18",
      number: "3",
      vector: Neuro_Counter,
      title: "Neuro Counter",
      description:
        "Deep learning-powered counting of people, cars, bicycles, etc., entering or leaving areas or crossing virtual lines with high precision. Filters allow excluding certain categories (e.g. staff) or segmenting by attributes (like clothing color). Helps with foot traffic analytics, operations planning, and optimizing layouts.",
    },
    {
      id: "19",
      number: "4",
      vector: Crowd_Detector,
      title: "Crowd Detector",
      description:
        "Detects when people count exceeds your custom threshold and sends instant alerts—whether indoors or outdoors. Uses neural-net tech to minimize false positives, so you only get notified when it really matters. Works with TRASSIR NeuroStation and supports offload analytics.",
    },
    {
      id: "20",
      number: "5",
      vector: Pose_Detector,
      title: "Pose Detector",
      description:
        "Classifies postures like falling, raised arms, or other unusual body language using neural networks + tracking + customizable scripts. You can set zones, sensitivity, recognition speed and quality levels to match hardware. Great for public safety, healthcare, ATMs, etc.",
    },
    {
      id: "21",
      number: "6",
      vector: Workplace_Detector,
      title: "Workplace Detector",
      description:
        "Automatically tracks employees’ working time by monitoring presence, absences, late starts, early leaves via camera. Sends alerts when someone is away longer than allowed, generates daily attendance reports, and lets you set schedules and parameters. Saves time, improves accountability.",
    },
    {
      id: "22",
      number: "7",
      vector: Fire_and_Smoke,
      title: "Fire and Smoke",
      description:
        "Image-analysis powered detection spots smoke or fire faster than traditional sensors, often before alarms trigger. Integrated alerts (audio, messages, sirens, dry-contacts) help teams respond immediately. Ideal for open spaces & warehouses where early warning saves lives.",
    },
    {
      id: "23",
      number: "8",
      vector: Queue_Detector,
      title: "Queue Detector",
      description:
        "Uses neural-net object counting to monitor queue lengths and send alerts when they exceed allowed limits. Helps businesses optimize staffing and service points with real-time stats and reporting. Works even in crowded scenes with high accuracy.",
    },
    {
      id: "24",
      number: "9",
      vector: Heat_Map,
      title: "Heat Map on Map",
      description:
        "Visualizes customer movement across your floor or space to reveal where people linger and how they walk through. Helps optimize display placement, layouts, and traffic flow. Perfect for retail, events, and public venues.",
    },
  ],
};
